import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { ForgotPasswordPage } from 'src/app/pages/forgot-password/forgot-password.page';
import { SignupPage } from '../signup/signup.page';
import { Events } from 'src/app/services/events';
import { Keyboard } from '@capacitor/keyboard';
import { setAuthentication } from "../../../store/actions/authenticate";
import { setUser } from "../../../store/actions/user";
import { setSubscription } from "../../../store/actions/subscription";
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { CommonService } from 'src/app/services/common/common.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { Input } from '@angular/core';
import { setCompletedDraftSorting, setLocationSorting } from 'src/store/actions/location';
import { ActionNeededModalPage } from 'src/app/modals/action-needed-modal/action-needed-modal.page';
import { CoachMarkService } from 'src/app/services/coach-mark/coach-mark.service';
import { TermsAcceptModalPage } from 'src/app/modals/terms-accept-modal/terms-accept-modal.page';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { AnalyticsEvents } from 'src/app/services/analytics/analytics.events';
import { EncouragementService } from 'src/app/services/encouragement/encouragement.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  myForm: UntypedFormGroup;
  submitted = false;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  loading = false;
  unauthorize = false;
  confirmUser = false;
  userNotfound = false;
  loginFeild = true;
  continue = false;
  selectedEmail = '';
  
  @Input() source: string; // Receives source parameter from modal
  @Input() deeplinkDecryptedData: any; // ✅ Add this to receive decrypted data
  deeplinkUsername: string = 'Alex';
  deeplinkLocationName: string = '123 Beautiful Acres';
  get isDeeplinkLogin(): boolean {
    return this.source === 'deeplink' || this.source === 'app-download';
  }
  @ViewChild('inputEmail', { static: false }) inputEmail;
  @ViewChild('inputPassword', { static: false }) inputPassword;
  // @ViewChild('btn_verified1', { static: false }) btn_verified1;

  constructor(private modalCtrl: ModalController,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private authServices: AuthenticationService,
    private common: CommonService,
    private constant: ConstantService,
    private store: Store<any>,
    private coachMark: CoachMarkService,
    private events: Events,
    private analytics: AnalyticsService,
    private encouragement: EncouragementService,
  ) {}

  ngOnInit() {
    this.myForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.][a-zA-Z]{1,4}) *$')]],
      password: ['', [Validators.required, Validators.minLength(4)]]
    })

    // Prefer componentProps, fallback to localStorage
    const stored = localStorage.getItem('deeplinkDecryptedData');
    const decrypted = this.deeplinkDecryptedData || (stored ? JSON.parse(stored) : null);

    // Support both `Username` and `username` just in case
    this.deeplinkUsername = decrypted?.Username || decrypted?.username || this.deeplinkUsername;
    this.deeplinkLocationName = decrypted?.locationname || decrypted?.locationName || this.deeplinkLocationName;
  }

  ionViewWillEnter() {
    setTimeout(() => {
      console.log("avyu")
      this.inputEmail.setFocus();
      if (Capacitor.getPlatform() !== "web") {
        Keyboard.show();
      }
    }, 1000)
  }

  async forgotPassword() {
    this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: ForgotPasswordPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  blurEmail() {
    this.userNotfound = false;
    this.loginFeild = false;
  }

  emailFocus() {
    this.loginFeild = true;
  }

  blurPassword() {
    this.unauthorize = false;
    this.confirmUser = false;
  }

  passwordFocus() {
    this.unauthorize = false;
    this.confirmUser = false;
  }

  hideShowPassword() {
    console.log("Hiiii");
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
    console.log(this.passwordType, "this.passwordTypethis.passwordTypethis.passwordType")
  }

  checkForHideShow(passwordType){
    if(passwordType == 'text'){
      return "Hide"
    }else{
      return "Show"
    }
  }

  goBack() {
    setTimeout(() => {
      this.modalCtrl.dismiss();
    }, 300)
  }

  async signup() {
    // pull decrypted deeplink data (from props or storage)
    const stored = localStorage.getItem('deeplinkDecryptedData');
    const decrypted = this.deeplinkDecryptedData || (stored ? JSON.parse(stored) : null);
    const contactMethod = decrypted?.method;
    const contactValue = decrypted?.contactValue;

    // persist for SignupPage fallbacks
    if (contactMethod?.toLowerCase() === 'email' && contactValue) {
      localStorage.setItem('emailFromLogin', contactValue);
    } else if (contactMethod?.toLowerCase() === 'mobile' && contactValue) {
      localStorage.setItem('mobileFromLogin', contactValue);
    }

    this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: SignupPage,
      cssClass: 'modal_login',
      backdropDismiss: false,
      componentProps: {
        from: 'login',
        contactMethod,
        contactValue,
        username: contactMethod?.toLowerCase() === 'email' ? contactValue : '',
        decryptedData: decrypted,
      },
    });
    return await modal.present();
  }

  async signupFromEmail() {

    localStorage.setItem("emailFromLogin", this.myForm.controls.email.value);
    this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: SignupPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  get errorCtr() {
    return this.myForm.controls;
  }

  continueClicked() {
    this.submitted = true;
    if (!this.myForm.controls.email.valid) {
      console.log('Email not valid.')
      return false;
    } else {
      this.submitted = false;
      let dataMobile = {
        type: "email",
        value: this.myForm.controls.email.value
      }
      this.loading = true;
      this.common.callApi(
        this.constant.CHECK_USER_REGISTERED_V2,
        dataMobile,
        'POST',
        '',
        false,
        false,
        false
      ).subscribe(async (results: any) => {
        console.log("checkDataMobile === ", results);
        // Only a real account can sign in. users/check also answers 200 for "Secondary Contact
        // Exist" (an address connected to someone's account as an extra contact method, which
        // signup needs to tell apart) -- matching on status alone sent those to the password
        // screen, where they could only ever fail. Match the message so a secondary is refused
        // here, with the same "no account" wording: saying it is a connected contact would tell
        // anyone typing an address that some account holds it (§5.3b, no user enumeration).
        if (results.message == "User Exist") {
          this.loading = false;
          this.userNotfound = false;
          this.continue = true;
          this.selectedEmail = this.myForm.controls.email.value;
          setTimeout(() => {
            console.log("avyu")
            this.inputPassword.setFocus();
            if (Capacitor.getPlatform() !== "web") {
              Keyboard.show();
            }
          }, 1000)
          this.myForm.controls.password.setValue("");
          console.log("email exist");
        } else {
          console.log("email not exist");
          this.userNotfound = true;
          this.loading = false;
        }
        // if (results.Items.length == 0) {
        //   console.log("email not exist");
        //   this.userNotfound = true;
        //   this.loading = false;
        // } else {
        //   this.loading = false;
        //   this.userNotfound = false;
        //   this.continue = true;
        // this.selectedEmail = this.myForm.controls.email.value;
        //   this.myForm.controls.password.setValue("");
        //   console.log("email exist");
        // }
      }, (err) => {
        // this.userNotfound = false;
        this.loading = false;
        console.log("error in checkDataMobile", err?.error?.message);
        if (err?.error?.message == "User Not Exist") {
          this.userNotfound = true;
        }
      })
    }
  }

  notYou() {
    this.continue = false;
    this.userNotfound = false;
    this.unauthorize = false;
  }

  // async onSubmit() {
  //   if (this.loading) return;
  //   this.submitted = true;
  //   if (!this.myForm.valid) {
  //     console.log('All fields are required.')
  //     return false;
  //   } else {
  //     this.loading = true;
  //     let dataMobile = {
  //       email: this.myForm.value.email,
  //       password: this.myForm.value.password
  //     }

  //     this.loading = true;
  //     this.common.callApi(
  //       this.constant.LOGIN_V2,
  //       dataMobile,
  //       'POST',
  //       '',
  //       false,
  //       false,
  //       false
  //     ).subscribe(async (results: any) => {
  //       console.log("Login === ", results);
  //       if (results.user.hasOwnProperty("idToken")) {
  //         // this.loading = false;
  //         this.userNotfound = false;
  //         this.continue = true;
  //         this.selectedEmail = this.myForm.controls.email.value;
  //         // this.myForm.controls.password.setValue("");
  //         console.log("email exist");

  //         let accessToken = results.user.accessToken.jwtToken;
  //         let sessionToken = results.user.idToken.jwtToken;
  //         let refreshToken = results.user.refreshToken.token;
  //         let sub = results.getUserDetail[0].id
  //         let email = results.user.idToken.payload.email

  //         let uData = {
  //           token: {
  //             accessToken: accessToken,
  //             sessionToken: sessionToken,
  //             refreshToken: refreshToken
  //           },
  //           cognitoUser: {
  //             attributes: {
  //               email: email,
  //               sub: sub
  //             }
  //           },
  //           login: true
  //         }
  //         await this.store.dispatch(setAuthentication(uData));

  //         sessionStorage.removeItem('signupFormDraft');

  //         this.events.publish('loginn', {
  //           login: true,
  //         });

  //         this.getUserDetail(sub);

  //       }
  //       else {
  //         console.log("email not exist");
  //         this.userNotfound = true;
  //         this.loading = false;
  //       }
  //       // if (results.Items.length == 0) {
  //       //   console.log("email not exist");
  //       //   this.userNotfound = true;
  //       //   this.loading = false;
  //       // } else {
  //       //   this.loading = false;
  //       //   this.userNotfound = false;
  //       //   this.continue = true;
  //       //   this.selectedEmail = this.myForm.controls.email.value;
  //       //   this.myForm.controls.password.setValue("");
  //       //   console.log("email exist");
  //       // }
  //     }, (err) => {
  //       if (err?.error?.error?.name == 'UserNotConfirmedException') {
  //         this.confirmUser = true;
  //         this.loading = false;
  //       } else if (err?.error?.error?.name == 'NotAuthorizedException' || err?.error?.code == 'INVALID_LOGIN') {
  //         // Backend now returns a single generic INVALID_LOGIN for wrong-password / no-account (no enumeration).
  //         this.unauthorize = true;
  //         this.loading = false;
  //       } else {
  //         this.loading = false;
  //       }
  //     })

  //     // await this.authServices.signIn(this.myForm.value.email, this.myForm.value.password).then(async (signInres: any) => {
  //     //   console.log(signInres, "ahi ahiu ahi");

  //     //   if (signInres == 'UserNotConfirmedException') {
  //     //     this.confirmUser = true;
  //     //     this.loading = false;
  //     //   } else {
  //     //     if (signInres != 'NotAuthorizedException') {
  //     //       this.confirmUser = false;
  //     //       await this.authServices.GetAuthenticationToken().then(async (tokenRes: any) => {
  //     //         console.log(tokenRes, "for token");

  //     //         localStorage.setItem("password", this.myForm.value.password);

  //     //         if (tokenRes) {
  //     //           let accessToken = tokenRes.accessToken.jwtToken;
  //     //           let sessionToken = tokenRes.idToken.jwtToken;
  //     //           let refreshToken = tokenRes.refreshToken.token;

  //     //           // set userData and token into Redux
  //     //           let uData = {
  //     //             token: {
  //     //               accessToken: accessToken,
  //     //               sessionToken: sessionToken,
  //     //               refreshToken: refreshToken
  //     //             },
  //     //             cognitoUser: {
  //     //               attributes: {
  //     //                 email: signInres.attributes.email,
  //     //                 sub: signInres.attributes.sub
  //     //               }
  //     //             },
  //     //             login: true
  //     //           }
  //     //           await this.store.dispatch(setAuthentication(uData));

  //     //           this.events.publish('loginn', {
  //     //             login: true,
  //     //           });
  //     //           this.getUserDetail(signInres);
  //     //         } else {
  //     //           this.loading = false;
  //     //         }
  //     //       }, (err) => {
  //     //         this.loading = false;
  //     //         console.log(err, "error");
  //     //       })
  //     //     } else {
  //     //       this.loading = false;
  //     //       this.unauthorize = true;
  //     //       // this.userNotfound = true;
  //     //     }
  //     //   }
  //     // })

  //   }
  // }

  // getUserMeta(email) {
  //   let body = {
  //     id: email,
  //     filter: 'user#meta'
  //   }
  //   this.common.callApi(
  //     this.constant.USER_FILTER,
  //     body,
  //     'POST',
  //     '',
  //     false,
  //     false,
  //     true
  //   ).subscribe(async (results: any) => {
  //     console.log('User Meta -> ', results.user);
  //     this.loading = false;
  //     let userData = results.user[0]
  //     let uData = {
  //       email: userData.pk,
  //       cognitoID: userData.id,
  //       fullname: userData.fullname,
  //       userID: userData.id
  //     };

  //     await this.store.dispatch(setUser(uData));
  //     this.getUserAlert(uData, email)
  //     // this.modalCtrl.dismiss();


  //   }, err => {
  //     console.log('error in User Details - ', err);
  //   })
  // }

  // getUserAlert(userData, email) {
  //   let body = {
  //     id: email,
  //     filter: 'user#alert'
  //   }
  //   this.common.callApi(
  //     this.constant.USER_FILTER,
  //     body,
  //     'POST',
  //     '',
  //     false,
  //     false,
  //     true
  //   ).subscribe(async (results: any) => {
  //     console.log('User Alert -> ', results.user);
  //     this.loading = false;
  //     let data = results?.user[0];
  //     let len = results?.user?.length

  //     console.log(userData, data, len, "??????????")

  //     if (len > 0) {
  //       this.modalCtrl.dismiss()
  //       let uData = {
  //         email: userData.email,
  //         cognitoID: userData.userID,
  //         fullname: userData.fullname,
  //         userID: userData.userID,
  //         alert_preferences: data?.alert_preferences,
  //         mobile: data?.alert_preferences?.mobile == null ? "NA" : data?.mobile,
  //         country_code: data?.alert_preferences?.country_code
  //       };
  //       await this.store.dispatch(setUser(uData));
  //       this.router.navigate(['/tabs/jobsites']);
  //     } else {
  //       this.modalCtrl.dismiss()
  //       this.router.navigate(['/signup-preferences']);
  //     }
  //     // let uData = {
  //     //   email: userData.pk,
  //     //   cognitoID: userData.id,
  //     //   fullname: userData.fullname,
  //     //   userID: userData.id
  //     // };

  //     // await this.store.dispatch(setUser(uData));
  //     // this.modalCtrl.dismiss();

  //   }, err => {
  //     console.log('error in User Details - ', err);
  //   })
  // }

  async onSubmit() {
    if (this.loading) return;
    this.submitted = true;
    if (!this.myForm.valid) {
      console.log('All fields are required.');
      return false;
    }
    this.loading = true;
    this.unauthorize = false;
    this.confirmUser = false;
    this.userNotfound = false;
    // Match Cognito username normalization used by the API
    const email = (this.myForm.value.email || '').toLowerCase().trim();
    const password = this.myForm.value.password;
    try {
      const signInRes: any = await this.authServices.signIn(email, password);
      if (signInRes === 'UserNotConfirmedException') {
        this.confirmUser = true;
        this.loading = false;
        return;
      }
      // Wrong password / unknown user / other Cognito auth failures — one generic UX
      if (
        signInRes === 'NotAuthorizedException' ||
        signInRes === 'UserNotFoundException' ||
        typeof signInRes === 'string'
      ) {
        this.unauthorize = true;
        this.loading = false;
        return;
      }
      const tokenRes: any = await this.authServices.GetAuthenticationToken();
      if (!tokenRes || typeof tokenRes === 'string') {
        this.unauthorize = true;
        this.loading = false;
        return;
      }
      const idToken = tokenRes.getIdToken ? tokenRes.getIdToken() : tokenRes.idToken;
      const accessToken = tokenRes.getAccessToken ? tokenRes.getAccessToken() : tokenRes.accessToken;
      const refreshToken = tokenRes.getRefreshToken ? tokenRes.getRefreshToken() : tokenRes.refreshToken;
      const payload = idToken.payload || (idToken.getPayload && idToken.getPayload()) || {};
      const sessionTokenJwt = idToken.jwtToken || idToken.getJwtToken();
      const accessTokenJwt = accessToken.jwtToken || accessToken.getJwtToken();
      const refreshTokenStr = refreshToken.token || refreshToken.getToken();
      // App Dynamo user id (stamped on Cognito after confirm). Needed for GET /user/:id
      const appUserId = payload['custom:userId'];
      const cognitoSub = payload.sub;
      const userEmail = payload.email || email;
      if (!appUserId) {
        console.error('Missing custom:userId on ID token');
        this.unauthorize = true;
        this.loading = false;
        return;
      }
      this.userNotfound = false;
      this.continue = true;
      this.selectedEmail = this.myForm.controls.email.value;
      // Mirror Amplify session into Redux so existing headerInit keeps working until Step 2
      const uData = {
        token: {
          accessToken: accessTokenJwt,
          sessionToken: sessionTokenJwt,
          refreshToken: refreshTokenStr,
        },
        cognitoUser: {
          attributes: {
            email: userEmail,
            // App historically stores APP user id in `sub` (used by getUserDetail / navigation)
            sub: appUserId,
            cognitoSub: cognitoSub,
          },
        },
        login: true,
      };
      await this.store.dispatch(setAuthentication(uData));

      // Track login event
      this.analytics.trackUserLoggedIn(appUserId, 'email', {
        user_id: appUserId,
        email: userEmail,
      });
      
      sessionStorage.removeItem('signupFormDraft');
      this.events.publish('loginn', { login: true });
      this.getUserDetail(appUserId);
    } catch (err) {
      this.loading = false;
      console.log("error in checkDataMobile", err?.error?.message);
      if (err?.error?.message == "User Not Exist") {
        this.userNotfound = true;
      }
    }
  }

  getUserDetail(id) {
    console.log(id, "======");
    this.common.callApi(
      this.constant.USER_DETAIL_V2 + id,
      "",
      'GET',
      '',
      false,
      false,
      true
    ).subscribe(async (results: any) => {
      console.log('User Details -> ', results);
      this.common.callApi(
        this.constant.CHECK_USER_SUBSCRIPTION_STATUS + id,
        '',
        'GET',
        '',
        false,
        false,
        true
      ).subscribe(async (subscriptionResults: any) => {
        const subscriptionType = subscriptionResults?.user_item?.[0]?.sub_status;
        if (subscriptionType) {
          await this.store.dispatch(setSubscription({
            subcripition_type: subscriptionType
          }));
        }

        await this.store.dispatch(setUser(results));
        this.encouragement.hydrateConfig();

        const accepted = await this.ensureTermsAccepted(results);
        if (!accepted) {
          this.loading = false;
          return;
        }
        this.modalCtrl.dismiss();

        const mismatchHandled = await this.handleDeeplinkEmailGuard();
        if (mismatchHandled) {
          this.loading = false;
          return; // action-needed modal is shown; skip navigation
        }

        this.navigatePostLogin(results);
      }, async () => {
        await this.store.dispatch(setUser(results));
        const accepted = await this.ensureTermsAccepted(results);
        if (!accepted) {
          this.loading = false;
          return;
        }

        this.modalCtrl.dismiss();

        const mismatchHandled = await this.handleDeeplinkEmailGuard();
        if (mismatchHandled) {
          this.loading = false;
          return;
        }

        this.navigatePostLogin(results);
      });
    }, err => {
      console.log('error in User Details - ', err);
      this.loading = false;
    })
  }

  private async ensureTermsAccepted(user: any): Promise<boolean> {
    if (user?.termsAcceptedAt && user?.termsVersion) {
      return true;
    }
    const modal = await this.modalCtrl.create({
      component: TermsAcceptModalPage,
      cssClass: 'modal_all confirmation_modal_top',
      backdropDismiss: false
    });
    
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (!data?.accepted) {
      return false;
    }
    await this.saveTermsAcceptance(user.id);
    return true;
  }

  private saveTermsAcceptance(userId: string): Promise<void> {
    const data = {
      id: userId,
      sk: 'user#meta',
      updateBody: {
        termsAcceptedAt: new Date().toISOString(),
        termsVersion: '2026-06-23'
      }
    };

    return new Promise((resolve) => {
      this.common.callApi(
        this.constant.USER_UPDATE_FILTER,
        data,
        'PUT',
        '',
        false,
        false,
        true
      ).subscribe(() => resolve(), () => resolve());
    });
  }

  // "Connect existing punch lists" must appear only once — after the first sign-in
  // (or via the manual link in Profile/jobsites). Returning users, who already have
  // the onboarding flag set, skip straight to the app instead of seeing it every login.
  private navigatePostLogin(results: any): void {
    if (!results.hasOwnProperty("alert_preferences")) {
      this.router.navigate(['/signup-preferences']);
      return;
    }
    if (results?.onboarding?.connectPunchlistDone) {
      this.store.dispatch(setLocationSorting('atoz'));
      this.store.dispatch(setCompletedDraftSorting('atoz'));
      this.events.publish("openJobsite", true);
      this.router.navigate(['/tabs/jobsites']);
    } else {
      this.coachMark.markAsViewed('connectPunchlistDone');
      this.router.navigate(['/signup-punchlist-email']);
    }
  }

  // inside LoginPage, add helper
  private async handleDeeplinkEmailGuard(): Promise<boolean> {
    if (!this.isDeeplinkLogin) return false;

    const stored = localStorage.getItem('deeplinkDecryptedData');
    const decrypted = this.deeplinkDecryptedData || (stored ? JSON.parse(stored) : null);

    const deeplinkMethod = decrypted?.method?.toLowerCase();
    const deeplinkEmail = decrypted?.contactValue;
    const loginEmail = (this.myForm?.value?.email || '').trim().toLowerCase();

    if (deeplinkMethod === 'email' && deeplinkEmail && loginEmail && loginEmail !== deeplinkEmail.trim().toLowerCase()) {
      const modal = await this.modalCtrl.create({
        component: ActionNeededModalPage,
        cssClass: 'modal_all',
        backdropDismiss: false,
        componentProps: {
          contactMethod: deeplinkMethod,
          contactValue: deeplinkEmail
        }
      });
      await modal.present();
      return true; // mismatch handled; halt normal flow
    }

    return false; // no mismatch; continue
  }

  async resendOtp() {
    // resendCode
    await this.authServices.resendCode(this.myForm.value.email).then(async (codeREs: any) => {
      console.log(codeREs, "--------");

      if (codeREs) {
        this.modalCtrl.dismiss();
        const modal = await this.modalCtrl.create({
          component: SignupPage,
          cssClass: 'modal_login',
          backdropDismiss: false,
          componentProps: {
            from: "login",
            username: this.myForm.value.email
          }
        });
        return await modal.present();
      }
    })
  }

  setFocus(nextElement) {
    console.log(nextElement)
    nextElement.setFocus();
  }

  setFocusButton() {
    document.getElementById('btn_verified1').click();
  }

  // setFocus1() {
  //   console.log("SET FOCUS")
  //   this.btn_verified1.setFocus()
  //   // this.btn_verified1.el.focus();
  // }

}
